import styled from 'styled-components'
import { ButtonIcon } from 'ui/components/Button'

const PanelBackButton = styled(ButtonIcon)`
  margin-right: 1.25rem;
`

export default PanelBackButton
